/**
 * stop-watching-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

/**
 * A client transmits a {@link StopWatchingRequest} to remove or "unwatch"
 * an entry on the user's watchlist.
 */
export class StopWatchingRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_STOP_WATCHING;
	public static tag : MessageTag = MessageTag.REQ_STOP_WATCHING;

  /**
   * Construct a new {@link StopWatchingRequest}.
   */
  constructor (
    public objectId : number,
    public watchId : number,
    public forcePartialUpdate : boolean = false)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/watchlists/stop-watching-request.ts